import React from 'react';
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { FcOpenItem } from '../../interfaces/fx.interface';
import { formatFc } from '../../utils/fcDocuments';
import { formatMoney } from '../../utils/format';
import { formatDate } from '../../utils/dateUtils';

/** B4-C: open foreign-currency documents beside the BDT statement (open now, at their carrying value). */
const FcOpenItemsTable: React.FC<{ items?: FcOpenItem[] | null }> = ({ items }) => {
  if (!items || items.length === 0) return null;
  return (
    <Box sx={{ mt: 2 }} data-testid="fc-open-items" data-help-section="common.fcOpenItems">
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Open foreign-currency documents (open today)</Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell data-help="common.fcOpenItems.col.doc">Document #</TableCell>
            <TableCell data-help="common.fcOpenItems.col.date">Date</TableCell>
            <TableCell data-help="common.fcOpenItems.col.rate" align="right">Rate</TableCell>
            <TableCell data-help="common.fcOpenItems.col.foreign" align="right">Open (foreign)</TableCell>
            <TableCell data-help="common.fcOpenItems.col.bdt" align="right">Open (BDT)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(i => (
            <TableRow key={`${i.documentNumber}-${i.currency}`}>
              <TableCell>{i.documentNumber}</TableCell>
              <TableCell>{formatDate(i.documentDate)}</TableCell>
              <TableCell align="right">{i.exchangeRate}</TableCell>
              <TableCell align="right">{formatFc(i.currency, i.foreignOutstanding)}</TableCell>
              <TableCell align="right">{formatMoney(i.bdtOutstanding)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default FcOpenItemsTable;
